<script setup>
import { computed } from 'vue';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const isDefaultScreen = computed(() => {
  return (
    props.config.isDefaultScreen &&
    ((props.config.welcomeHeading && props.config.welcomeHeading.length !== 0) ||
      (props.config.welcomeTagline && props.config.welcomeTagline.length !== 0))
  );
});
</script>
<!-- 更改小部件预览显示_002 -->
<template>
  <div>
    <div class="bg-white dark:bg-slate-900 p-4 rounded-t-lg">
      <div class="relative top-px">
        <div class="flex items-center justify-start">
          <img
            v-if="config.logo"
            :src="config.logo"
            class="mr-2 rounded-full logo"
            :class="'h-8 w-8 mb-1'"
          />
          <div>
            <div class="flex items-center justify-start gap-1">
              <span
                class="text-base font-medium leading-3 text-slate-900 dark:text-white"
              >
                {{ config.websiteName }}
              </span>
              <div
                v-if="config.isOnline"
                class="w-2 h-2 bg-green-500 rounded-full"
              />
            </div>
            <span class="mt-1 text-xs text-slate-600 dark:text-slate-400">
              {{ config.replyTime }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isDefaultScreen"
      class="bg-slate-25 dark:bg-slate-800 px-4 py-5"
    >
      <div class="overflow-auto max-h-60">
        <h2 class="mb-2 text-2xl break-words text-slate-900 dark:text-white">
          {{ config.welcomeHeading }}
        </h2>
        <p class="text-sm break-words text-slate-600 dark:text-slate-100">
          {{ config.welcomeTagline }}
        </p>
      </div>
    </div>
  </div>
</template>
